import { z } from 'zod';

const NAME_MIN_LENGTH = 1;
const NAME_MAX_LENGTH = 1024;

export const QConfigStructureSchema = z.record(
  z.string().uuid(),
  z
    .string()
    .trim()
    .max(NAME_MAX_LENGTH, {
      message: `ความยาวต้องไม่เกิน ${NAME_MAX_LENGTH} ตัวอักษร`,
    })
    .min(NAME_MIN_LENGTH, {
      message: 'กรุณากรอกข้อมูลให้ครบถ้วน',
    }),
);

export type QConfigStructureFormInput = z.infer<typeof QConfigStructureSchema>;
